"use client";

import UspRoadmap from "@/components/newPageComponent/usp/UspRoadmap";
import LpUspBanner from "@/components/pageComponent/lp-usp/lpUspBanner";
import UspShortageDesk from "@/components/pageComponent/lp-usp/uspShortageDesk";
import UspSolutionDesk from "@/components/pageComponent/lp-usp/uspSolutionDesk";
import UspVideoDesk from "@/components/pageComponent/lp-usp/uspVideo";
import UspVisitPoweredByDesktop from "@/components/newPageComponent/usp/UspVisitPoweredByDesktop";
import UspAlumniDesktop from "@/components/newPageComponent/usp/UspAlumniDesktop";
import UspFaqDesk from "@/components/pageComponent/lp-usp/UspFaq";
import UspWhatLanding from "@/components/pageComponent/us-pathway/uspWhatLanding";
import UspVisitRoadmapDesktop from "@/components/newPageComponent/usp/UspVisitRoadmapDesktop";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import VisitPageHeader from "@/components/common/VisitPageHeader";

const DesktopPageLp = () => {
  return (
    <main className=" bg-white w-full">
      <VisitPageHeader />
      <LpUspBanner />
      <UspVisitRoadmapDesktop />
      <UspShortageDesk />
      <UspSolutionDesk />
      <UspWhatLanding />
      <UspVideoDesk />
      <UspRoadmap />
      <UspAlumniDesktop />
      <UspVisitPoweredByDesktop />
      <UspFaqDesk />
      <div className="w-full">
        <GlobalFooter />
      </div>
    </main>
  );
};

export default DesktopPageLp;
